import { buildGoogleReviewSchemas } from '../../../../reviews/reviews-jsonld';

/**
 * The video testimonial embedded on the testimonials page (#34 convention:
 * one VideoObject per embedded video). Previously lived inline in
 * app.routes.ts's static route data alongside the Review schemas; moved
 * here 2026-09-14 so the whole page's JSON-LD is composed and set at
 * runtime (see buildTestimonialsPageSchemas + TestimonialsContentComponent)
 * from inside this route's own lazy chunk instead of the eager route-data
 * bundle.
 */
const TESTIMONIAL_VIDEO_SCHEMA: Readonly<Record<string, unknown>> = {
  '@type': 'VideoObject',
  name: 'Online Skype Bass Lessons Testimonial For Russ Rodgers Bass Guitar Instruction',
  description:
    'Testimonial from an online Skype bass guitar student of Russ Rodgers on how well remote bass lessons really work.',
  thumbnailUrl: 'https://i.ytimg.com/vi/dw2Ske9ruJs/hqdefault.jpg',
  uploadDate: '2014-01-06T22:38:57-08:00',
  duration: 'PT6M34S',
  contentUrl: 'https://www.youtube.com/watch?v=dw2Ske9ruJs',
  embedUrl: 'https://www.youtube.com/embed/dw2Ske9ruJs',
};

/**
 * Full JSON-LD schema array for /bass-lessons/testimonials: the video
 * testimonial followed by one Review per text-bearing Google review. Set at
 * runtime via SEOService.setRouteSchemas (see TestimonialsContentComponent)
 * rather than the route's static data.seo.jsonLd, so buildGoogleReviewSchemas()
 * — and the ~28kB GOOGLE_REVIEWS array it reads — only loads inside this
 * page's own lazy chunk instead of shipping on every page's initial bundle.
 *
 * Order is load-bearing: e2e/data/pages.ts's testimonials `schemas`
 * expectation is `[BreadcrumbList, VideoObject, ...Review]`, positional
 * after the shell's `[EducationalOrganization, WebPage]` prefix and the
 * route's own BreadcrumbList (still emitted from static route data —
 * unaffected by this override, see SEOService.getRouteBreadcrumbs).
 */
export function buildTestimonialsPageSchemas(): Record<string, unknown>[] {
  return [TESTIMONIAL_VIDEO_SCHEMA, ...buildGoogleReviewSchemas()];
}
